import React from 'react';
import * as _ from 'lodash';

export function AgentDataColumnFormatter(cellContent) {
  const firstName = _.get(cellContent, 'agent.firstName', '');
  const lastName = _.get(cellContent, 'agent.lastName', '');
  const fullName = [firstName, lastName].filter(Boolean).join(' ');
  const agentId = _.get(cellContent, `agent.agentId`, '');

  return (
    <>
      <div className="text-dark-75 font-weight-bolder font-size-lg">
        {agentId}
      </div>
      <div className="text-dark-75 font-weight-bolder font-size-lg">
        {fullName}
      </div>
    </>
  );
}
